<!-- Container-fluid starts-->
<div class="container-fluid">

  <!-- Filter -->
  <div class="row">
    <div class="col-lg-2 col-md-12 col-12">
      <div class="card">
        <div class="card-header">
          <h5>Filter</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 col-md-4 col-12 form-group">
              <label class="form-label">Type</label>
              <ng-multiselect-dropdown
              [placeholder]="'-- type --'"
              [settings]="dropdownSettingsCategories"
              [data]="dropdownListCategories"
              [(ngModel)]="selectedItemsCategories"
              (onSelect)="onItemSelectType($event)"
              (onSelectAll)="onSelectAllType($event)"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="col-lg-12 col-md-4 col-12 form-group">
              <label class="form-label">Device</label>
              <ng-multiselect-dropdown
              [placeholder]="'-- device --'"
              [settings]="dropdownSettingsDevice"
              [data]="dropdownListDevice"
              [(ngModel)]="selectedItemsDevice"
              (onSelect)="onItemSelectDevice($event)"
              (onSelectAll)="onSelectAllDevice($event)"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="col-lg-12 col-md-4 col-12 form-group">
              <label class="form-label">Country</label>
              <ng-multiselect-dropdown
              name="country"
              [placeholder]="'-- country --'"
              [settings]="dropdownSettingsCountry"
              [data]="countries"
              [(ngModel)]="selectedItemsCountry"
              (onSelect)="onItemSelectCountry($event)"
              (onSelectAll)="onSelectAllCountry($event)"
              >
              </ng-multiselect-dropdown>
            </div>
            </div>
            <div class="form-group align-items-center">
              <button class="btn btn-pill btn-sm {{btnColor}}" type="button" placement="top" ngbTooltip="apply filter" (click)="onFilter()" name="btnFilter">
              {{btnName}}</button>
              <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="clear filter" (click)="onClear()" name="btnClear">
                Clear</button>
              </div>
          </div>
      </div>
    </div>

    <div class="col-lg-10 col-md-12 col-12">
      <div class="card">
        <div class="card-body custom-datatable">
          <ngx-datatable
          class='bootstrap'
          [rows]="offersData"
          [columnMode]="ColumnMode.flex"
          [externalPaging]="true"
          [count]="page.totalElements"
          [offset]="page.pageNumber"
          [limit]="page.size"
          (page)="setPage($event)"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          (sort)="sort($event)"
          >
          <ngx-datatable-column name="offerName" [flexGrow]="2">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Offer</span>
             </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a href="pub/offers/{{ row.offerId }}">{{ row.offerName }}</a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="name" [flexGrow]="1" prop="country.name">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Country</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <i class="flag-icon flag-icon-{{row.country.alpha2Code | lowercase}}"></i>&nbsp;
              {{ row.country.name}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Payout" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Payout</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.payout | currency:"USD":"symbol":"1.1-3"}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="offerCategory.id" [flexGrow]="1" prop="offerCategory.id">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Type</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="row.offerCategory.id==1">Click</div>
                <div *ngIf="row.offerCategory.id==2">Credit Card Submit</div>
                <div *ngIf="row.offerCategory.id==3">Download</div>
                <div *ngIf="row.offerCategory.id==4">Email/Zip Submit</div>
                <div *ngIf="row.offerCategory.id==5">Mobile install</div>
                <div *ngIf="row.offerCategory.id==6">PIN Submit</div>
                <div *ngIf="row.offerCategory.id==7">Trial</div>
                <div *ngIf="row.offerCategory.id==8">WAP Billing</div>
                <div *ngIf="row.offerCategory.id==9">Other</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="row.offerDevices" [flexGrow]="1" >
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Device</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span *ngFor="let dev of row.offerDevices">
              <i class="fa fa-desktop" name="desktop" ngbTooltip="desktop" *ngIf="dev.id==1">&nbsp;</i>
              <i class="fa fa-gamepad" name="game" ngbTooltip="game console" *ngIf="dev.id==2">&nbsp;</i>
              <i class="fa fa-mobile-phone" name="phone" ngbTooltip="phone" *ngIf="dev.id==3">&nbsp;</i>
              <i class="fa fa-tablet" name="tablet" ngbTooltip="tablet" *ngIf="dev.id==4">&nbsp;</i>
              <i class="fa fa-film" name="tv" ngbTooltip="TV" *ngIf="dev.id==5">&nbsp;</i>
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="epc" [flexGrow]="2" [sortable]="false">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()"></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <small>
                <!-- TST: {{row.capDetails.currentValue}} / {{row.capDetails.setValue}}<br> -->
                <div *ngIf="row.capDetails.setValue == 0; else elseBlock">
                  CAP: <span style="color:rgb(16, 197, 10);">Off</span><br>
                </div>
                <ng-template #elseBlock>
                  <div *ngIf="(row.capDetails.setValue - row.capDetails.currentValue) != 0; else elseBlock1">
                    CAP: {{row.capDetails.setValue - row.capDetails.currentValue}}<br>
                  </div>
                  <ng-template #elseBlock1>
                    CAP: <span style="color:red;">exided</span><br>
                  </ng-template>
                </ng-template>
                CR: {{ row.cr | percent}} / CR Global: {{ row.crGlobal | percent}}<br>
                EPC: {{ row.epc | currency}} / EPC Global: {{ row.epcGlobal | currency}}
              </small>
            </ng-template>
          </ngx-datatable-column>

          <!-- <ngx-datatable-column name="cr" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">CR</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.offerCr3 | percent}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="epc" [flexGrow]="1" >
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">EPC</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.offerEpc3 | currency}}
            </ng-template>
          </ngx-datatable-column> -->

          <ngx-datatable-column name="createdAtUtc" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Live since</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.createdAtUtc | date:'d/M/yyyy'}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Status" [flexGrow]="1" prop="offerStatus.publisherStatus">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Status</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div *ngIf="row.offerStatus.globalStatus=='Expired'">
                {{ row.offerStatus.globalStatus }}
              </div>
              <div *ngIf="row.offerStatus.globalStatus=='Disabled'">
                Disabled
              </div>
              <div *ngIf="row.offerStatus.globalStatus=='Active'">
                <div *ngIf="row.offerStatus.publisherStatus=='Active'">
                  <button class="btn btn-pill btn-xs btn-success" type="button" placement="top" name="btnStatus"  (click)="onStatus(row)">
                    {{ row.offerStatus.publisherStatus }}</button>
                </div>
                <div *ngIf="row.offerStatus.publisherStatus=='Disabled'">
                  <button class="btn btn-pill btn-xs btn-danger" type="button" placement="top" name="btnStatus" (click)="onStatus(row)">
                    {{ row.offerStatus.publisherStatus }}</button>
                </div>
              </div>

            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
